import { render, staticRenderFns } from "./product-target-picker.vue?vue&type=template&id=09a7d271&scoped=true&"
import script from "./product-target-picker.vue?vue&type=script&lang=js&"
export * from "./product-target-picker.vue?vue&type=script&lang=js&"
import style0 from "./product-target-picker.vue?vue&type=style&index=0&id=09a7d271&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a7d271",
  null
  
)

export default component.exports